export default [
  {
    type: 'update_date',
    content: 'تم التحديث في: ١٨  يوليو ٢٠٢٣',
  },
  {
    type: 'text',
    content:
      '<strong>١.١</strong> تشكل هذه الشروط والأحكام اتفاقية مُلزِمَة نظامًا بينك (إما شخصيًا أو نيابة عن كيان تمثلونه) وشركة نخلة لتقنية نظم المعلومات ذ.م.م. ("تمارا")، ويشار إليها فيما يلي باسم "نحن"، فيما يتعلق بجميع جوانب خدمات تمارا و/أو استخدامك لتطبيق الجوال أو وصولك إلى موقعنا على الويب، بالإضافة إلى أي قناة وسائط أو موقع ويب أو تطبيق جوال متعلق أو مرتبط به ومن خلال وصولك إلى واستخدامك لتطبيق الجوال أو موقع الويب. أنتم تُقِرّون بأنكم قد قرأت وفهمت ووافقت على الالتزام بهذه الشروط والأحكام، بصيغتها المعدلة من وقت لآخر. إذا كنت لا توافق على هذه الشروط والأحكام، فعليك التوقف عن استخدام أو الوصول إلى تطبيق الجوال و/أو موقع الويب على الفور. إذا كنت تستخدم تطبيق الجوال أو موقع الويب نيابة عن الغير بما في ذلك، على سبيل المثال لا الحصر، أي كيان تجاري، فأنت تتعهد بأنك مفوض ولديك سلطة إلزام الغير بهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١</strong> لا يعد التاجر الذي تشتري منه السلع أو الخدمات باستخدام خدمات تمارا طرفًا في هذه الشروط والأحكام وأي شروط سارية بينكم وبين التاجر مستقلة عن هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١</strong> نحتفظ بحقنا، وَفقا لتقديرنا المطلق، في إجراء تغييرات أو تعديلات على هذه الشروط والأحكام في أي وقت ولأي سبب. سنزودكم بإخطار مدته ثلاثون (30) يوم عمل بأي تغيير يطرأ على هذه الشروط والأحكام عبر وسائل الاتصال المتفق عليها كما هو موضح أدناه. و ستتاح لك الفرصة للاعتراض على أي تغيير مماثل في غضون عشرة (10) أيام عمل بعد تلقي إخطار من تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١</strong> يُعَدّ هذا التمهيد جزء لا يتجزأ من هذه الشروط والأحكام.',
  },
  {
    type: 'subtitle',
    content: '٢. تعريفات',
  },
  {
    type: 'text',
    content:
      ' تحمل الإشارات والكلمات والعبارات والمصطلحات التالية المدلولات الموضحة أمام كل منها في هذه الشروط والأحكام:',
  },
  {
    type: 'text',
    content:
      '<strong>الأنظمة المطبقة:</strong> تعني أية أنظمة ولوائح منطبقة تخضع لها تمارا و/أو العميل.',
  },
  {
    type: 'text',
    content: '<strong>العميل:</strong> يعني عميل التاجر الذي أنشأ حساب تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>النزاع:</strong> يعني أي طلب استرداد أو خصم أو تعويض أو دعوى متقابلة أو نزاع من أي نوع يقدمه العميل ضد التاجر فيما يتعلق بالسلع أو الخدمات التي نتج عنها معاملة معتمدة',
  },
  {
    type: 'text',
    content:
      '<strong>القوة القاهرة:</strong> تعني أي ظرف خارج عن السيطرة بما في ذلك، على سبيل المثال لا الحصر: (1) القضاء والقدر أو الفيضانات أو الجفاف أو الزلازل أو الكوارث الطبيعية الأخرى؛ (2) الوباء أو الجائحة؛ (3) الهجوم الإرهابي أو الحرب الأهلية أو الاضطرابات المدنية أو أعمال الشغب أو الحرب أو التهديد بالحرب أو التحضير لها أو النزاع المسلح أو فرض العقوبات أو الحظر أو قطع العلاقات الدبلوماسية؛ (4) التلوث النووي أو الكيميائي أو البيولوجي أو اختراق حاجز الصوت؛ (5) أي نظام أو أي إجراء تتخذه حكومة أو جهة عامة، بما في ذلك على سبيل المثال لا الحصر فرض قيود على التصدير أو الاستيراد أو الحصة أو الحظر، أو عدم منح الترخيص أو الموافقة اللازمة؛ (6) انهيار المباني أو نشوب حريق أو وقوع انفجار أو حادث؛ و(7) انقطاع أو فشل خدمة المرافق.',
  },
  {
    type: 'text',
    content:
      '<strong>بيانات التعريف:</strong> تعني البيانات المطلوبة التي يجب أن يقدمها العميل إلى تمارا لإنشاء حساب له مع تمارا، كما جمعتها تمارا أو التاجر أو منصة التاجر لأغراض تقديم خدمات تمارا للعملاء.',
  },
  {
    type: 'text',
    content:
      '<strong>حقوق الملكية الفكرية:</strong> تعني أي براءات اختراع ونماذج منفعة وحقوق في الاختراعات وحقوق التأليف والنشر والحقوق المجاورة والعلامات التجارية وعلامات الخدمة والأسماء التجارية وأسماء النطاقات وحقوق الاستحواذ والسمعة الحسنة والحق في رفع دعوى نتيجة البيع بالخِداع والتَّضليل أو المنافسة غير العادلة وحقوق في التصاميم، وحقوق في برامج الحاسوب، وحقوق قاعدة البيانات، وحقوق الحفاظ على سرية المعلومات (بما في ذلك المعرفة والأسرار التجارية) وأي حقوق ملكية فكرية أخرى، بما في ذلك جميع طلبات هذه الحقوق (وحقوق التقدم للحصول علي هذه الحقوق واستمناحها)، والتجديدات أو التمديدات المتعلقة بهذه الحقوق، وحقوق المطالبة بالتمتع بالأولوية في هذه الحقوق وجميع الحقوق المماثلة أو المكافئة أو أشكال الحماية القائمة أو التي ستبقى، الآن أو في المستقبل، في أي جزء من العالم.',
  },
  {
    type: 'text',
    content:
      '<strong>منصة التاجر:</strong> تعني الوسائل، بما في ذلك على سبيل المثال لا الحصر مواقع الويب والتطبيقات، والتي تتيح لعدة تجار تقديم السلع والخدمات للعملاء من خلال منصة واحدة.',
  },
  {
    type: 'text',
    content:
      '<strong>التاجر:</strong> عني أي كيان تجاري يقدم خدمات تمارا لعملائه وَفقا لاتفاقية بينه وبين تمارا، أو بين تمارا ومنصة التاجر، حسب ما يُستَجَدّ من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>تطبيق الجوال:</strong> يعني تطبيق تمارا للجوّال المتاح للتنزيل من المتاجر الرقمية ذات العلاقة.',
  },
  {
    type: 'text',
    content:
      '<strong>صافي المبلغ:</strong> يعني المبلغ الإجمالي الذي يتعين على العميل دفعه، بما في ذلك، أي ضريبة قيمة مضافة ورسوم شحن فيما يتعلق بطلب الشراء الذي يؤدي إلى معاملة واحدة معتمدة مطروحًا منها: (1) أي مبالغ مستردة؛ و(2) أي خصومات أو ائتمانات أو تخفيضات يطالب بها العميل ويوافق عليها التاجر ذي الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>طلب الشراء:</strong> يعني الطلب المقدم من العميل من خلال النظام الأساسي أو موقع الويب أو تطبيق الجوال أو موقع التاجر على الويب أو أي تطبيقات أو نقاط بيع أخرى لاستخدام خدمات تمارا لشراء سلع أو خدمات من التاجر أو منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>المبالغ المستردة:</strong> تعني المبلغ المتنازع عليه الذي دفعه العميل إلى تاجر يستخدم خدمات تمارا فيما يتعلق بمعاملة معتمدة تُستَردّ قيمتها لاحقًا إلى العميل بعد تسوية هذا النزاع.',
  },
  {
    type: 'text',
    content:
      '<strong>حساب تمارا:</strong> عني الحساب الذي أنشأه العميل لاستخدام خدمات تمارا، والذي سيخضع استخدامه وتشغيله لهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>خدمات تمارا:</strong> تعني خدمات الدفع التي تقدمها تمارا، وَفق ما يُستَجَدّ من وقت لآخر، والتي يختارها العميل على موقع التاجر أو منصة التاجر أو في أي نقطة بيع أخرى مع التاجر أو على منصة التاجر التي يختار العميل بمُوجِبها الشراء. تخضع البضائع أو الخدمات من التاجر أو منصة التاجر باستخدام خدمات تمارا لهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>المعاملة: </strong> تعني الطلب المقدم عبر حساب تمارا الخاص بكم، بناءً على طلب شراء، للاستفادة من خدمات تمارا من أجل إكمال وتسوية طلب الشراء هذا مع التاجر ذي الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>بيانات المعاملة:</strong> تعني جميع البيانات المتعلقة بطلب الشراء والمعاملة',
  },
  {
    type: 'text',
    content:
      '<strong>نحن:</strong> الإشارات إلى ضمير المتكلم المنفصل "نحن" أو ضمير المتكلم المتصل "نا" أو أية ضمائر أخرى مماثلة في هذه الشروط والأحكام هي إشارات إلى تمارا والكيانات والأشخاص التابعين لها',
  },
  {
    type: 'text',
    content:
      '<strong>الموقع الإلكتروني:</strong>  يعني موقع تمارا على العنوان التالي: https://tamara.co',
  },
  {
    type: 'text',
    content:
      '<strong>أنتم:</strong>  الإشارات إلى ضمير المُخاطَب المنفصل "أنتم" أو المُخاطَب المتصل "ــكُم" أو أية ضمائر أخرى مماثلة في هذه الشروط والأحكام هي إشارات إلى العميل ذي الصلة المشار إليه في بيانات التعريف التي يجب تقديمها قبل استخدام خدمات تمارا',
  },
  {
    type: 'subtitle',
    content: '٣. الأهلية والصلاحية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٣</strong> باستخدام خدمات تمارا، فإنك تتعهد وتُقِرّ بأنك تتمتع بالأهلية النظامية للدخول في هذه الشروط والأحكام وأن عمركم يتجاوز حَدّ الثمانية عشر (18) عامًا.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٣</strong> ذا سجّلت بصفتك كيانًا تجاريًا أو شخصًا اعتباريًا أو أي كيان آخر، فإنك تتعهد وتُقِرّ بأن لديك السلطة والقدرة اللازمتين للدخول إلى كيانك وإلزامه بهذه الشروط والأحكام، وأنك والشركة ستمتثلون لجميع الأنظمة والمتطلبات المنطبقة.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٣</strong> بالنقر فوق الموافقة على هذه الشروط والأحكام، فإنك تُقِرّ بأنك قبلت هذه الشروط والأحكام إلكترونيًا.',
  },
  {
    type: 'subtitle',
    content: '٤. الحسابات والتسجيل:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٤</strong> تتطلب عملية تسجيل حساب تمارا منكم تزويد تمارا بمعلومات شخصية معينة لأغراض (1) إنشاء حساب تمارا؛ (2) تقديم أية خدمات تمارا؛ و(3) الامتثال لأية أنظمة أو لوائح منطبقة، بما في ذلك، على سبيل المثال لا الحصر، الامتثال لالتزامات "اعرف عميلك". قد تتضمن هذه المعلومات اسمك الكامل وعنوانك وبريدك الإلكتروني ورقم الهاتف وعمرك. أنت تُقِرّ وتوافق على أن أية معلومات شخصية مقدمة من قبلكم هي صحيحة ودقيقة وكاملة ومحدثة، وفي حال حدوث أي تغيير على هذه البيانات أو أي معلومات وظروف أخرى قد تؤثر على أهليتك للاستمرار في استخدام خدمات تمارا فإنه يجب عليك إخطار تمارا على الفور وفقا لهذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٤</strong> أنت توافق بمُوجِب هذه الشروط والأحكام على الإفصاح عن جميع التزاماتكم المالية، بِناءً على طلب تمارا أو أيٍّ من وكلائها أو متعاقديها من الباطن، والامتناع عن حجب أية معلومات قد تكون مؤثرة أو مهمة لأيٍّ من أطراف اتفاقية التمويل.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٤</strong> أنت توافق بمُوجِبه على أنكم ستكون مسؤول عن أي نشاط تحت حساب تمارا الخاص بكم وتوافق على الحفاظ على التدابير الأمنية المناسبة لتفاصيل حسابك على أساس مستمر.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٤</strong> إذا فقدت كلمة المرور الخاصة بك أو سُرِقَت منك، أو إذا كنت تعتقد أن ثمّة وصول غير مصرح به إلى حساب تمارا الخاص بك، فيجب عليك تغيير كلمة المرور لحساب تمارا الخاص بكم و إخطارنا على الفور. أنت مسؤول عن أية معاملات تُجرى باستخدام بيانات اعتماد حساب تمارا المسروقة ما لم تخطرنا على الفور بإيقاف نشاطه مؤقتًا، وتتلقى رسالة من تمارا تفيد بأن حساب تمارا الخاص بكم قد تقرر إيقاف نشاطه مؤقتًا أو إلغائه.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.٤</strong> لا يحق لك مشاركة بيانات اعتماد حساب تمارا الخاص بكم مع أي شخص آخر. وأنت تُقِرّ وتوافق على رد قيمة أي معاملة أُجريَت باستخدام حساب تمارا الخاص بك إلى تمارا والتي طلبتموها أنتم أو أي شخص آخر وصل إلى خدمات تمارا من خلال استخدام اسم المستخدم أو كلمة المرور الخاصة بك، سواء سمحتم بذلك أم لم تسمحوا بهذا الوصول.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.٤</strong> يجب عليك إخطار تمارا على الفور بأي نشاط احتيالي أو غير نظامي مشتبه به أو فعلي تَحَدَّدَ نتيجة لاستخدامك لخدمات تمارا. قد يؤدي عدم تنفيذ ذلك إلى تعليق أو إنهاء حساب تمارا الخاص بك، بالإضافة إلى أي إجراء نظامي إضافي آخر تتخذه تمارا وَفقا لتقديرها الكامل. وعندما ينشأ النشاط الاحتيالي أو غير النظامي المشتبه به أو الفعلي من تاجر أو منصة تجارية باستخدام خدمات تمارا، يجب عليكم إبلاغ تمارا على الفور عن هذا التاجر قبل اتخاذ أي إجراء آخر.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.٤</strong> وَفقا لتقدير تمارا الكامل، إذا كانت لديها أي شكوك في أن أيًا من المعلومات التي قدمتها غير صحيحة أو غير دقيقة أو غير كاملة أو غير مُحَدَّثَة، دون الإخلال بأي حقوق أو تعويضات أخرى، وَفقا لهذه الشروط والأحكام أو وَفقا للأنظمة المنطبقة، يحق لتمارا إيقاف أو تقييد الوصول إلى الخدمات و/أو تطبيق الجوال و/أو الموقع الإلكترون.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.٤</strong> قد تُجرِي تمارا، وَفقا لتقديرها الكامل، أي استفسارات تراها ضرورية (سواء بشكل مباشر أو من خلال الغير)، وتطلب منكم تقديم مزيد من المعلومات أو المستندات حسب الضرورة. إذا كنت صاحب عمل أو مسجل نيابةً عن صاحب عمل، فقد تتضمن هذه المعلومات أو المستندات ترخيصًا تجاريًا و/أو مستندات رسمية للشركة و/أو مستندات أخرى توضح سلطة أي شخص للتصرف نيابة عنكم. وأنت تُقِرّ وتوافق على تقديم أيّة معلومات و/أو مستندات إلى تمارا عند الطلب. أنتم تُقِرّون وتوافق أيضًا على أنه إن لم تقدروا على فعل ذلك، يجوز لتمارا، دون أية مسؤولية، تقييد أو تعليق أو سحب وصولكم إلى الخدمات أو تطبيق الجوال أو الموقع الإلكتروني. وتحتفظ تمارا بحقها في إلغاء أي حسابات لم يجرِ التأكد أو التحقق من صحتها أو حسابات لم تكن نشطة، حسب تقدير تمارا الكامل.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.٤</strong> عند الانتهاء من عملية التسجيل، فإنك تُقِرّ و توافق على أنكم قد قرأتم هذه الشروط والأحكام وفهمتموها وتوافق على الالتزام بها. وتُعَدّ هذه الشروط والأحكام متضمنة سياسة خصوصية تمارا، المتوفرة https://tamara.co/privacy-policy.html ووَفق ما يُستَجَدّ من وقت لآخر.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.٤</strong> في حالة رفض طلبك فيما يتعلق بالحصول على حساب تمارا أو أي من خدمات تمارا، سنبلغكم بسبب هذا الرفض في غضون خمسة (5) أيام عمل.',
  },
  {
    type: 'subtitle',
    content: '٥. خدمات تمارا:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٥</strong> تمارا هي مزود مدفوعات عبر الإنترنت يقدم للعملاء مجموعة متنوعة من طرق الدفع عند شراء سلع أو خدمات من خلال العديد من التجار أو منصات التجار..',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٥</strong> يعرض موقع تمارا الإلكتروني وتطبيق الجوال قائمة بالتجار المستقلين الذين يقبلون تمارا كخيار دفع، وَفق ما يُستَجَدّ من وقت لآخر. أَبرَم هؤلاء التجار اتفاقيات مُلزِمَة مع تمارا لتقديم هذه المُنتَجات أو الخدمات من خلال مواقع الويب أو التطبيقات أو منصات التجار.',
  },
  {
    type: 'subtitle',
    content: '٦. التواصل الإلكتروني:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٦</strong> من خلال إنشاء حساب تمارا، فإنك تُقِرّ وتوافق على أنك ستتواصل معنا إلكترونيًا. لذا، فإنك توافق على أنه يجوز لتمارا تقديم جميع المراسلات وبيانات الدفع والشروط والأحكام والمعلومات المطلوب منا تقديمها بمُوجِب النظام وجميع المراسلات المتعلقة بأية شكاوى ومعلومات أخرى إليكم إلكترونيًا إلى عنوان البريد الإلكتروني الذي قدمتموه إلينا.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٦</strong> لضمان قدرتنا على التواصل معكم إلكترونيًا، فإنكم توافقون على أنه من مسؤوليتكم إخطارنا على الفور بأي تغيير في عنوان بريدكم الإلكتروني ورقم جوّالكم أو أيّة معلومات أخرى تقدمونها لنا. قد نتصل بكم من حين لآخر لطلب تحديث لهذه المعلومات وأيّة معلومات أخرى متعلقة بحساب تمارا الخاص بكم.',
  },
  {
    type: 'subtitle',
    content: '٧. حقوق الملكية الفكرية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٧</strong> أنت تُقِرّ بأن جميع حقوق الملكية الفكرية على الموقع الإلكتروني و/أو تطبيق الجوال (حسب الاقتضاء)، هي ملكية لتمارا وشركاتها التابعة ، إلى الحد الأقصى الذي يسمح به النظام.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٧</strong> يُعَدّ شعار تمارا والرموز المرتبطة به علامات تجارية مملوكة لشركة تمارا. ولا يجوز استخدام علامات تمارا التجارية فيما يتعلق بأي مُنتَج أو خدمة لا تقدمها تمارا، بما في ذلك أي مُنتَج أو خدمة تنتقص من قَدر تمارا أو تضر بسمعتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٧</strong> يحظر عليك استخدام أي علامة تجارية أو أي حقوق ملكية فكرية تخص تمارا، من أي جزء من خدمات تمارا، ويحظر عليكم استنساخ أو تعديل خدمات تمارا أو إجراء أية عملية إعداد أو نشر أو تنفيذ أو إرسال أو عرض، أو بَثّ أو أي وسيلة أخرى لاستغلال خدمات تمارا ما لم تسمح تمارا بذلك أو تأذن به صراحةً كتابةً. كما لا يجوز لكم، وأنتم توافقون على عدم قيام الآخرين أو تمكينهم من نَسخ أو فَك تجميع أو إجراء هندسة عكسية أو تفكيك أو محاولة اشتقاق كود مصدر أو فك تشفير أو تعديل أو إنشاء أعمال مشتقة من خدمات تمارا أو أي جزء منها (باستثناء ما هو محظور فقط إلى الحد الذي تحظر الأنظمة المنطبقة).',
  },
  {
    type: 'subtitle',
    content: '٨. استخدام موقع الويب وتطبيق الجوال:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٨</strong> يحظر استخدام موقع تمارا الإلكتروني و/أو تطبيق تمارا لنشر أي من المحتوى التالي: أي استخدام للغة بذيئة أو فاحشة أو إهانات أو إساءة ثقافية أو دينية أو أي محتوى سياسي أو نقدي أو مادة قد تهدد المصلحة العامة أو الأمن القومي أو تتسبب في التشهير أو التطاول أو القذف أو أي محتوى آخر قد يكون مسيئًا أو فاحشًا أو غير لائق.',
  },
  {
    type: 'subtitle',
    content: '٩. قوائم المُنتَجات والتوافر:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٩</strong> أنت تدرك أن تمارا مجرد مزود مدفوعات ولا تتحمل أية مسؤولية عن تصنيع أو شحن أو إنتاج أو تسليم أي من المُنتَجات أو الخدمات المشتراة عبر تمارا. وعليه، لن تكون تمارا مسؤولة عن التوافر أو التأهل أو أي خاصية أخرى لأي مُنتَجات معروضة على موقع التاجر أو التطبيق أو منصة التاجر.',
  },
  {
    type: 'subtitle',
    content: '١٠. خدمة ما بعد بيع المُنتَجات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٠</strong> تمارا غير مسؤولة عن أي مُنتَجات أو خدمات تُباع من خلال أي مواقع إلكترونية أو تطبيقات أو منصات تجارية خاصة بالتاجر. سيوفر هذه المُنتَجات والخدمات ويدعمها التجار أو مصنعوهم أو وكلاؤهم المحليون فقط، فضلًا عن مورّدِيهم، وَفقا للشروط والأحكام المرتبطة بكل مُنتَج أو خدمة. تستبعد تمارا صراحةً أي ضمان من أي نوع للمُنتَجات أو الخدمات المباعة على مواقع الويب والتطبيقات ومنصات التجار. يجب توجيه أي طلبات للدعم الفني أو خدمة العملاء أو خدمة ما بعد البيع فيما يتعلق بالمُنتَجات أو الخدمات إلى التاجر ذي الصلة.',
  },
  {
    type: 'subtitle',
    content: '١١. المدفوعات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١١</strong> بمجرد إنشاء حساب تمارا وَفقا لهذه الشروط والأحكام، ستتمكن من الوصول إلى خدمات تمارا عندما تختار الدفع مقابل السلع أو الخدمات باستخدام خيار الدفع لخدمات تمارا مع التاجر أو منصة التاجر ذات الصلة.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١١</strong> تتيح خدمات تمارا شراء سلع أو خدمات من تاجر أو منصة تجارية. وعندما تختارون أحد خيارات الدفع في تمارا، قد تنطبق شروط وأحكام مختلفة بالإضافة إلى هذه الشروط والأحكام، وقد تُحَصِّل تمارا رسومًا، والتي يتعين عليك دفعها لاحقًا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١١</strong> أنت مسؤول عن فهم وقبول جميع الرسوم المرتبطة بطلب الشراء الخاص بكم كما هو مقرر أثناء عملية الدفع. حيثما ينطبق أي مبلغ متأخر، فإنكم تتعهد بدفعه إلى تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١١</strong> بمجرد اختياركم لخدمات تمارا في نقطة بيع التاجر أثناء عملية الدفع، سيُطلب منكم اختيار طريقة دفع تصبح فعالة وملزمة بينكم وبين تمارا فيما يتعلق بطلب الشراء.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١١</strong> قد تكون رسوم الخدمة منطبقة على طرق دفع معينة و/أو تجار معيّنين. سيُعرَض مبلغ هذه الرسوم بوضوح أثناء المغادرة. أنتم مسؤولون عن مراجعة المبلغ الإجمالي الخاص بكم قبل إنهاء المعاملة للتأكد من أنّكم على علم بجميع الرسوم المطبقة.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١١</strong> في حالة عدم توفر هذه المعلومات بالفعل عبر موقع تمارا الإلكتروني و/أو تطبيق تمارا، يحق لكم طلب نسخة من الاتفاقية الكاملة التي أبرمتها معنا في غضون عشرة (10) أيام عمل بعد إبرام الاتفاقية، وكذلك أي بيانات معاملات ذات صلة (بما في ذلك جميع الرسوم والتكلفة المتكبدة خلال فترة زمنية محددة وجميع التكاليف والرسوم الإضافية، في حالة التخلف عن السداد أو السداد المبكر للتمويل) على أساس ربع سنوي.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١١</strong> تُقِرّ بأنّك تتحمل المسؤولية الكاملة عن أي طلب شراء أو معاملة أو أي رسوم مرتبطة بخدمات تمارا، بغض النظر عما إذا كانت السلع أو الخدمات ذات الصلة قد تسلمتموها أو قُدِّمَت إليكم بنجاح (حسب الاقتضاء).',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١١</strong> تحتفظ تمارا بحقّها في إجراء أي تغيير أو تعديل على أي طريقة دفع أو على توفير خدمات تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.١١</strong> توفر تمارا خدمات الدفع الإلكتروني من خلال مزودي خدمة خارجيين. ولا تتحمل تمارا أية مسؤولية عن أي خطأ أو ضرر أو أي خسارة قد تتعرض لها نتيجة استخدام طريقة الدفع الإلكترونية؛ إذ يقع ذلك ضمن نطاق مسؤولية مزود الخدمة الخارج.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١١</strong>  يجب عليك التأكد من أن لديك أموالاً كافية في حساب تمارا الخاص بكم، قبل تقديم طلب الشراء أو محاولة إتمام المعاملة. أنت وحدك مسؤول عن الامتثال لأي من حدود معاملات منطبقة.',
  },
  {
    type: 'text',
    content:
      '<strong>١١.١١</strong>  بمُوجِب هذه الشروط والأحكام، فإنّك توافق وتفوض تمارا بسحب المبلغ ذي الصلة اللازم لإتمام معاملة من بطاقة الدفع المخزنة في حساب تمارا الخاص بكم في تاريخ استحقاق الدفع. وفي حالة رفض معاملة بسبب نقص الأموال التي تغطي قسط التأمين، فستُجرَى محاولة لخصم هذه الأموال تلقائيًا كل يومين (2) إلى حين دفع المبلغ بالكامل. تحتفظ تمارا بحقها في إحالة قضيتكم إلى أية وكالة تحصيل ائتمان سارية و/أو مشاركة بياناتكم مع أية جهات تنظيمية سارية وَفقا لتقديرها الكامل.',
  },
  {
    type: 'text',
    content:
      '<strong>٢١.١١</strong>  بموجب هذه الاتفاقية ، أنت توافق على اعطائنا الأذن بالتحقق من سجلك الائتماني والحصول على تقريرك الائتماني و التحقق من هويتك عن الطريق النفاذ الوطني الموحد (نفاذ) أو أي مصادر بيانات أخرى ذات صلة، كما أنك تقر  بمعرفة أن تقريرك الائتماني قد يؤثر على قبول طلبك للدفع مع تمارا وذلك بحسب سلوكك الائتماني وسجل مدفوعاتك، كما قد تضطر تمارا إلى مشاركة معلومات عن تاريخ سلوكك الائتماني أو أي معلومة أخرى إلى الشركة السعودية للمعلومات الائتمانية (سمة) أو أي جهة أخرى معتمدة من قبل البنك المركزي السعودي(ساما).',
  },
  {
    type: 'text',
    content:
      '<strong>٣١.١١</strong>  أنت تتعهد وتقرّ بمُوجِبه أن لديكم أموالاً كافية متاحة للوفاء بأي التزامات مالية تجاه تمارا حسب الاقتضاء من وقت لآخر. ولتمارا الحق في التعاون مع التاجر في حالة عدم وفائك بالتزاماتك بالدفع. ويشمل ذلك التعاون، على سبيل المثال لا الحصر، تعليق الاشتراك/الخدمات ذات الصلة أو الاستيلاء على المُنتَج/البضائع إلى حين الوفاء بالدفعات.',
  },
  {
    type: 'text',
    content:
      '<strong>٤١.١١</strong>  أنت توافق بموجب هذه الاتفاقية على تفهمك وتحملك للعواقب المحتملة عند استخدام الخدمة التمويلية خلافاً للشروط المتفق عليها. وتوافق على أحقية تمارا (وحسب مطلق اختيارها) بإخطار الشركة السعودية للمعلومات الائتمانية ("سمة") في حالة تأخرك أو عجزك عن السداد.',
  },
  {
    type: 'text',
    content:
      '<strong>٥١.١١</strong>  أنت توافق بمُوجِبه على أنّك المستفيد الحقيقي من خدمات تمارا للدفع وأنّك لا تستخدم خدمات تمارا في أي عمليات غسيل أموال أو أنشطة غير نظامية أخرى.',
  },
  {
    type: 'subtitle',
    content: '١٢. استرداد المدفوعات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٢</strong>  تمارا غير مسؤولة عن أي قرار يتخذه التاجر أو منصة التاجر بشأن المبالغ المستردة، حسب الاقتضاء بينكم وبين التاجر أو منصة التاجر. قد تختار تمارا، مع ذلك، أن تلعب دورًا في تسهيل عمليات الاسترداد هذه وَفقا لتقديرها الخاص، شريطة ألا ينطوي هذا الدور على أية مسؤولية فيما يتعلق بأي استرداد. ومع ذلك، ستظل تمارا مسؤولة عن معالجة دفع أي مبلغ مسترد كما هو مقرر بينكم وبين التاجر أو منصة التاجر.',
  },
  {
    type: 'subtitle',
    content: '١٣. السرّية والخصوصية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٣</strong>   تمارا ملتزمة بالحفاظ على سرّية المعلومات والبيانات الائتمانية التي بحوزتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٣</strong>   أنت توافق بمُوجِبه على تقديم أيّة معلومات، بما في ذلك بيانات التعريف أو الوثائق التي تطلبها تمارا بشكل معقول للتحقق من هويتكم فيما يتعلق بحساب تمارا الخاص بكم أو أي استخدام لخدمات تمارا للدفع، وتفوضنا بإجراء أي استفسارات نعتقد أنها ضرورية من أجل التحقق من هويتكم. وتحتفظ تمارا بحقّها في إغلاق حساب تمارا الخاص بكم أو تعليق أو تقييد وصولكم إلى خدمات تمارا للدفع إذا لم نتمكن من الحصول على أيٍّ من هذه المعلومات أو التحقق منها بما يرضينا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٣</strong>   أنت توافق بموجب هذه الاتفاقية وتفوض تمارا في استخدام أي من أو جميع معلومات التعريف و البيانات الشخصية الخاصة بك التي تم جمعها من خلال المواقع الإلكترونية أو المنصات أو تطبيقات الهواتف المحمولة الخاصة بتمارا أو التجار من وقتٍ لآخر ويجوز استخدامها أو الإفصاح عنها إلى أشخاص آخرين . وقد يشمل ذلك مشاركة معلومات التعريف الخاصة بك وأية معلومات أخرى مع أطراف خارجية لأغراض التحقق من الائتمان ومكافحة غسل الأموال أو غيرها من الفحوصات المماثلة أو لأي غرض آخر تعتبره تمارا ضروريًا من أجل تمكين تمارا من تقديم خدمات الدفع لك والالتزام بجميع القوانين واللوائح المعمول بها.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١٣</strong>   أنت توافق على هذه الشروط والأحكام وعند دخولك أو استخدامك لموقع تمارا الإلكتروني أو تطبيق تمارا، فإنّكم توافقون بمُوجِبه على سياسة الخصوصية، علمًا بأننا نجمع بياناتكم الشخصية ونفهم آلية التعامل معها.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١٣</strong>   إذا كنت لا توافق على سياساتنا وممارساتنا، فلن تتمكن من استخدام موقع تمارا الإلكتروني أو تطبيق تمارا ونرجو عدم الاستمرار في استخدام خدماتنا.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١٣</strong>   يحق لك سحب موافقتكم على معالجة بياناتكم الشخصية في أي وقت، وَفقا للقيود التعاقدية والنظامية والاشعار الكتابي.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١٣</strong>   لا يجوز الإفصاح للغير عن أيّة معلومات تتلقونها بمُوجِب هذه الشروط والأحكام أو أي عقد آخر مبرم مع تمارا. يجب الوصول بِسرّية إلى أيّة معلومات تتعلق بأعمال تمارا، ضمن الحدود التي قد تؤثر سلبًا على أعمال تمارا، وستكونون مسؤولين عن تعويض تمارا عن أية خسارة في العمل أو السمعة، إذا حدث ذلك نتيجة لأي فعل ناتج عن وصولكم إلى هذه المعلومات.',
  },
  {
    type: 'subtitle',
    content: '٣. الأهلية والصلاحية:',
  },
  {
    type: 'list',
    content: [
      '(أ) أية مرتجعات.',
      ' (ب) أية خصومات أو ائتمانات أو تخفيضات يطالب بها العميل وتتم الموافقة عليها من قبل التاجر المعني. ',
    ],
  },
  {
    type: 'text',
    content:
      '<strong>١٧.٢</strong> القوة القاهرة : ويُـقصد بها أي حدث قدري، أو حادث فجائي غير ممكن توقعه ويستحيل دفعه، ومن ذلك على وجه العموم لا الحصر الحريق والفيضانات والعواصف والأعاصير والزوابع والنشاطات البركانية والزلازل، وكذا أية تصرفات أو أوامر أو طلبات تصدر من جهة سيادية أو حكومة و/أو أية هيئة يُـفترض أنها تعمل لصالح تلك الجهة، وكذا الحرب، سواء المعلنة أو غير المعلنة، والتصرفات المثيلة للحرب، والثورات، وحالات الشغب، والعصيان المدني، والاضطراب المدني، وكذا عمليات الاضراب، والتوقف عن العمل، و/أو ما شابة ذلك من حالات، وأي سبب آخر مثيل ويخرج عن نطاق تحكم أو سيطرة أي طرف، هذا ما لم يكن تنفيذه هو تنفيذ محل ضمان يسري بموجب تنازل صريح عن الإعفاء في حالة وقوع حدث القوة القاهرة.',
  },
  {
    type: 'text',
    content:
      '<strong>١٨.٢</strong> القوانين واجبة التطبيق: ويقصد بها الأنظمة السارية لدى دولة الإمارات العربية المتحدة والتي تنطبق على الاتفاقية.',
  },
  {
    type: 'subtitle',
    content: '٣. الأهلية والصلاحية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٣</strong> يعد استخدامك لخدمات الدفع من تمارا إقراراً منك بأهليتك الشرعية والقانونية لإبرام الاتفاقية الماثلة وفق هذه الشروط والأحكام واقراراً منك بأنك تجاوزت سن الثمانية عشر (١٨) عاماً.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٣</strong> وإذا قمت بالتسجيل بصفتك جهة عمل أو شخص اعتباري أو أي كيان آخر، فيكون إقرارا منك بأن لديك الصلاحية والأهلية اللازمة لإبرام الاتفاقية الماثلة ولإلزام الكيان الخاص بك بالشروط والأحكام الماثلة، وأنك كذلك كيان العمل ستلتزم بكل ما هو واجب التطبيق من قوانين واشتراطاتٍ تسري على - وتخضع لها- عملية استخدام الموقع الإلكتروني واستخدام خدمات الدفع من تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٣</strong> وأن قيامك بالنقر على الموافقة على شروط هذه الاتفاقية يعتبر إقراراً منك أنك قد أبرمت هذه الاتفاقية إلكترونياً وفقاً للأنظمة المعمول بها في دولة الإمارات العربية المتحدة .',
  },
  {
    type: 'subtitle',
    content: '٤. الحسابات والتسجيل:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٤</strong> يستلزم منكم عملية تسجيل الحساب وإتمام الاتفاقية أن تتقدموا إلى تمارا بمعلوماتٍ شخصية مُعينة لأغراض اعرف عميلك المعمول بها في المملكة، ومنها على وجه العموم لا الحصر الاسم بالكامل والعنوان والبريد الإلكتروني ورقم الهاتف والعمر، فأنت تقر وتوافق على أن يتم حفظ معلوماتٍ صحيحة ودقيقة وكاملة بل ومُحدثة بشأنكم على الحساب ، وإخطار تمارا على الفور بأية تغييرات تطرأ على معلومات التعريف الخاصة بك أو أية معلومات أو ظروف أخرى قد تؤثر على أهليتك للاستمرار في استخدام خدمات الدفع من تمارا أو تكون مطلوبة بخلاف ذلك وفقًا لشروط هذه الاتفاقية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٤</strong> أنت توافق بموجب هذه الاتفاقية على الإفصاح عن كافة المعلومات التي قد تكون مؤثرة أو ذات أهمية إلى اي طرف من أطراف اتفاقية التمويل.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٤</strong> أنت توافق بموجب هذه الاتفاقية على أن تتحمل المسؤولية عن كل نشاطٍ يجري في إطار حسابك، كما تلتزم بالموافقة على الحفاظ وباستمرار على سريان إجراءاتٍ أمنية على اسم المستخدم وكلمة المرور الخاصة بحسابك، هذا ما لم تصرح تمارا بغير ذلك كتابة.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٤</strong> إذا فُقدت أو سُرقت كلمة المرور الخاصة بك، أو إذا كنت تعتقد أن هناك وصولًا غير مصرح به إلى حساب تمارا الخاص بك، فيجب عليك تغيير كلمة المرور الخاصة بحساب تمارا وإخطارنا فورا، ويتحمل العميل مسؤولية أي معاملات تتم بإستخدام حسابه المسروق ما لم يبادر على الفور بإخطارنا بتعليق الحساب وتلقي رسالة من تمارا تفيد وتأكد غلق الحساب.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.٤</strong> وحيث أنه لا يجوز نقل أو حوالة حسابات المستخدم، فلهذا فأنت تقر وتوافق على أن ترد إلى تمارا قيمة أية عملية استخدام لحسابكم ، ولم تكن عملية صحيحة أو مُصرح بها أو تسري وفق القانون، وحدث ذلك من جانبك أو من جانب أي شخص يمكنه الدخول على الموقع الإلكتروني أو الخدمات أو خلافه من خلال استخدام اسم المستخدم أو كلمة المرور المحددة من جانبكم، بل وسواء سمحتم بذلك الدخول أم لا.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.٤</strong> وإذا كان لدى تمارا (وحسب مطلق اختيارها) ثمة شكوك بأن أية معلومة من المعلومات التي تقدمت بها هي معلومة غير صحيحة أو غير دقيقة أو غير كاملة أو غير محدثة، دونما إخلال بأية حقوق أخرى وتعويضاتٍ مكفولة لدى شركة تمارا، وفق الشروط والاحكام الماثلة أو بمقتضى القوانين واجبة التطبيق، فيكون لدينا الحق في إيقاف خدماتنا وإيقاف عملية دخولكم على الموقع الإلكتروني أو خدماته، أو تحديد هذا الدخول أو قصره.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.٤</strong> ويجوز لدى تمارا القيام (وحسب مطلق اختيارها بل وفي أي حين) بإبداء أية استفسارات تراها ضرورية (سواء تم ذلك بصورة مباشرة أو من خلال طرف من الغير)، وكذا وكذلك مطالبتكم بتقديم الرد وبمزيد من المعلومات أو المستندات، ودونما تقييد بما سلف بيانه، فإذا كنتم بمثابة جهة عمل أو مُسجلين بالنيابة عن جهة عمل، فيجوز أن تشمل هذه المعلومات أو المستندات الترخيص التجاري وغير ذلك من مستنداتٍ رسمية خاصة بالشركة و/أو مستنداتٍ تستعرض أية صلاحية مكفولة لأي شخص للعمل نيابة عنكم. فأنت تقر وتوافق على توفير أية معلوماتٍ و/أو مستندات إلى تمارا فور طلبها إياها. كما تقر وتوافق على أنه إذا تعذر عليك القيام بذلك، فيجوز لتمارا القيام ودونما أية مسؤولية عليه بتقييد أو إيقاف أو سحب عملية دخولكم على الموقع الإلكتروني. كما نحتفظ أيضا بالحق في إلغاء أية حساباتٍ لم يرد تأكيد بشأنها أو لم يتم التحقق منها أو أية حساباتٍ لم تكن مفعلة لمدة طويلة.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.٤</strong> وعند إتمام عملية التسجيل من جانبك فإنك تقر وتوافق بأنك اطلعت على الشروط والأحكام الماثلة بل وتفهمتها ووافقت على الالتزام بها، وكذلك سياسة الخصوصية بل وكل ما يطرأ عليها من تعديل من حين لآخر، حيث تعتبر السياسة وتعديلاتها - وبموجب هذه الاتفاقية - بمثابة جزء لا يتجزأ بل وتندرج ضمن الشروط والاحكام الماثلة.',
  },
  {
    type: 'subtitle',
    content: '٥. الخدمات',
  },
  {
    type: 'text',
    content:
      '<strong>١.٥</strong> تعتبر تمارا بمثابة سوق إلكتروني مصمم ليكون حلقة وصل كمركز تجارياً شاملاً للعديد من المحلات التجارية الكبرى عن طريق التعاقد مع أصحاب هذه المواقع او المحلات، ويتمثل هدفنا في القيام بتوفير دليل إرشادي لكبار المحلات التجارية وإعطاء العميل ميزة خيار الشراء الآن والدفع لاحقاً للعملاء مع إمكانية تقسّيم الفاتورة على 3 أو 6 دفعات ميسرة.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٥</strong> يعرض موقع تمارا منتجات يوفرها ويملكها تجار على منصاتهم الخاصة مستقلين ممن وافقوا على وضع قائمة بهذه المنتجات على الموقع الإلكتروني وقد اتفق هؤلاء التجار كتابة مع تمارا على القيام بتوفير المنتجات محل الطلبيات من خلال منصاتهم الإلكترونية.',
  },
  {
    type: 'text',
    content:
      '<strong>۳.٥</strong> رسوم الخدمة سيتم تطبيقها على خدمة "ادفعها بداية الشهر" وخدمة " قسم فاتورتك على 3 دفعات" على متاجر مُختارة. قيمة الرسوم موضحة عند الدفع، للتأكد يرجى مراجعة قيمة الطلب قبل الإنتهاء من عملية الشراء.',
  },
  {
    type: 'subtitle',
    content: '٦. المراسلات و التواصل الالكتروني',
  },
  {
    type: 'text',
    content:
      '<strong>١.٦</strong> عند انشاء حساب، فإنك تقر وتوافق على أنك ستتواصل معنا الكترونياً، وبالتالي توافق على استلام رسائل دورية من جانبنا وسوف يتواصل معك فريق تمارا عبر البريد الإلكتروني أو قد يرسل لكم معلوماتٍ عبر رسائل نصية قصيرة، وكذا القيام بنشر إخطاراتٍ على الموقع الإلكتروني كجزء من إدارة الأعمال المعتادة والتي ترتبط بعملية استخدامك للخدمات، وإنك تقر وتوافق بأن اختياركم عدم تطبيق وسائل التواصل المذكورة هو أمر من شأنه إحداث ثمة تأثير على عملية استخدامكم للخدمات.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٦</strong> لضمان تمكننا من التواصل معك إلكترونيًا، فأنت توافق على إخطارنا فوراً بأي تغيير في عنوان بريدك الإلكتروني أو أية معلومات أخرى تقدمها لنا ونتواصل معك وفقًا لها، بما في ذلك رقم هاتفك، من خلال تحديث معلومات التعريف وأية معلومات أخرى ذات صلة بحساب تمارا في أقرب وقت ممكن عملياً وعند الضرورة.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٦</strong> وإنك تقر وتوافق على أن تكون جميع الاتفاقات والاخطارات والافصاحات وغير ذلك من مراسلاتٍ مما نقوم بتقديمه اليكم الكترونيا هي مراسلاتٍ تستوفي أي اشتراط قانوني يستلزم تقديم تلك المراسلات على نحو كتابي.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.٦</strong> كما سيطلب منك موقع تمارا خلال عملية التسجيل الموافقة على أن نرسل لك رسائل بريد الكترونية أو إخطاراتٍ دعائية ترتبط بالموقع الإلكتروني وما به من خدمات، وأنت توافق على استلام رسائل نصية قصيرة لكل رقم هاتف تقدمه إلى تمارا، كما تقر بأنك المستخدم الرئيسي لرقم الهاتف الذي قدمته لنا، وتقر بأنه مسموح لك بتلقي رسالة نصية قصيرة على رقم الهاتف الذي قدمته لنا. كما توافق على تنبيهنا كلما توقفت عن استخدام رقم هاتف معين وإذا حدث في أي حين أن قررت أو أبديت عدم الرغبة في استلام رسائل البريد الإلكتروني الدعائية، فيمكنك اختيار عدم استلامها من خلال الضغط على الرابط الكائن في اسفل أية رسالة بريد إلكتروني دعائية.',
  },
  {
    type: 'subtitle',
    content: '٧. حقوق الملكية الفكرية والعلامات التجارية',
  },
  {
    type: 'text',
    content:
      '<strong>١.٧</strong> بالنسبة لجميع المحتوى الوارد على الموقع الإلكتروني، ومن ذلك على وجه العموم لا الحصر النص، وصور الجرافيك، وشعارات تمارا ، والازرار، والصور، والمقاطع الصوتية، وعمليات التحميل الرقمي، وتجميع البيانات، والبرامج الإلكترونية، فيعتبر ذلك المحتوى بمثابة ملكية بل وعمل تأليفي خاص بتمارا أو بمرخصيه، كما يخضع هذا المحتوى للحماية بموجب حق المؤلف وحقوق العلامات التجارية وبراءات الاختراع وغير ذلك من حقوق ملكية فكرية وقوانين. كما يكون المحتوى المجمع على الموقع الإلكتروني بمثابة ملكية حصرية لتمارا بل وحق تأليف لها، بل ويخضع للحماية بموجب حق المؤلف وحقوق العلامات التجارية وبراءات الاختراع وغير ذلك من حقوق ملكية فكرية وقوانين.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٧</strong> وتعتبر علامة تمارا وما يرتبط بها من رموز هي علاماتٍ تجارية خاصة ب تمارا ، علما بأنه لا يجوز استخدام العلامات التجارية لتمارا فيما يتعلق بأي منتج أو أية خدمة ليست معروضة على تمارا ، أو أي منتج أو خدمة من شأنها التقليل من شأن تمارا أو الإساءة لسمعتها.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.٧</strong> يحظر على العميل استخدام أية علامة تجارية أو أي حقوق ملكية فكرية تخص تمارا ، وذلك من أي جزء من الخدمات، كما يحظر عليه إعادة إنتاج الخدمات أو تعديلها أو إجراء أية عملية إعداد أو نشر أو تنفيذ أو إرسال أو عرض أو بث أو غير ذلك من وسائل استغلال الخدمات، هذا ما لم تسمح تمارا بذلك أو يأذن صراحة وبصورة كتابية، كما لا يجوز إجراء اعمال تفكيك لنظام الخدمات أو أية هندسية عكسية أو إعادة تشكيل لها، أو القيام بربط أي جزء من الخدمات بأي نظام عاكس أو تأطيره أو وضع أية برامج أو نصوص لغرض إزالة أي جزء من الخدمات أو فهرستها أو مسحها أو إجراء غير ذلك من عمليات استخراج للبيانات منه، أو القيام بتحميل عملية التشغيل و/ أو العمل الوظيفي لأي منحى من مناحي الخدمات بأحمال لا مبرر لها أو القيام بإعاقتها أو محاولة الحصول على إمكانية الدخول عليها دونما تصريح بذلك أو العمل على الإضرار بالخدمات أو ما يرتبط بها من أنظمة أو شبكات.',
  },
  {
    type: 'subtitle',
    content: '٨. استخدام الموقع الإلكتروني',
  },
  {
    type: 'text',
    content:
      '<strong>١.٨</strong> يحظر على العميل استخدام الموقع الإلكتروني لتمارا للدعاية عن منتج له أو القيام في قسم مراجعة المنتج (الخاص بالمنتجات المقيدة) أو في أي موضع آخر بالموقع (وذلك حسبما يتقرر وحسب مطلق اختيارنا) بأية عملية نشر للآتي: أية دعاية لغرض الاستقطاب أو أية إعلانات أو استخدام لغة مبتذلة أو مواد تشوبها البذاءة أو تحتوي على سباب أو تجاوزات من الناحية الثقافية أو الدينية أو أي محتوى سياسي نقدي أو مواد من شأنها إحداث تهديد للصالح العام أو الأمن القومي أو التسبب في إساءة السمعة أو القذف أو التشهير أو أي محتوى آخر قد تشوبه الإهانة أو البذاءة أو عدم اللياقة.',
  },
  {
    type: 'subtitle',
    content: '٩. قوائم المنتجات ومدى توافرها',
  },
  {
    type: 'text',
    content:
      '<strong>١.٩</strong> وستعمل تمارا دائماً على أن تقدم لك أفضل الخبرات بل ومستوى متميز من الخدمة حيث تبذل تمارا قصارى جهودها لتضمن أن منتجات المورد منتجاتٍ متاحة ومتوفرة، إلا أن تمارا لا تتحمل أي مسؤولية في حال عدم توافر أي منتجات لدى أي تاجر وكانت هذه المنتجات معروضة على الموقع الإلكتروني.',
  },
  {
    type: 'subtitle',
    content: '١٠. خدمة ما بعد البيع للمنتجات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٠</strong> تعتبر المنتجات المُباعة من خلال الموقع الإلكتروني الماثل والتي لا تحمل الاسم التجاري لتمارا هي منتجات يتم تقديم الخدمات بشأنها ودعمها من خلال التجار مصنعيها أو الوكلاء المحليين لها فقط وكذا مورديها، وذلك وفق الشروط والاحكام المرتبطة بكل منتج. كما لا تمنح تمارا أي ضمان من أي نوع بالنسبة للمنتجات المباعة على الموقع الإلكتروني. ولهذا يُرجى التواصل مع التجار عند الحاجة للدعم الفني أو خدمة العملاء أو خدمة ما بعد البيع فيما يتعلق بمنتجاتهم.',
  },
  {
    type: 'subtitle',
    content: '١١. المدفوعات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١١</strong> بمجرد إنشاء حساب لدى تمارا وفقاً لهذة الاتفاقية تمنحك تمارا القدرة على طلب استخدام خدمات الدفع من تمارا عندما تختار الدفع للحصول على السلع أو الخدمات باستخدام خيار الدفع الخاص بخدمات الدفع من تمارا لدى التاجر المعني أو على الموقع الإلكتروني الخاص بمنصة التجار.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١١</strong> تسمح لك خدمات الدفع من تمارا بشراء سلع أو خدمات من تاجر أو منصة تجار مع الدفع في وقت لاحق على أساس شروط السداد المحددة أثناء عملية الدفع وقد تشمل شروط السداد هذه مبالغ تأخير على النحو المحدد في عملية الدفع من خلال إبرام هذه الاتفاقية، أنت توافق وتقر بأنك قد فهمت وقبلت جميع الرسوم المرتبطة بطلب الشراء الخاص بك على النحو المحدد في عملية الدفع ، أما ما يتعلق بمبالغ التأخير فإنك تتعهد بدفعها لتمارا على أن تقوم تمارا بالتصدق بها في وجوه الخير تحت إشراف اللجنة الشرعية.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١١</strong> بمجرد أن تختار خدمة الدفع من تمارا في نقطة البيع الخاصة بالتاجر أثناء عملية الدفع، سيُطلب منك أن تختار من بين مجموعة من شروط السداد التي ستصبح سارية وملزمة فيما بينك وبين تمارا فيما يتعلق بطلب الشراء هذا. وتوفر تمارا وسائل سداد مختلفة على الموقع الإلكتروني منها السداد الكترونياً من خلال بطاقات الائتمان.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١١</strong> وتحتفظ تمارا بالحق في إجراء أي تغيير أو تعديل في وسيلة السداد أو عملية توفيرها.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١١</strong> توفر تمارا خدمات سداد الكتروني من خلال مقدمي خدمة من الغير، علماً بأن تمارا لا تقوم بتخزين أية بياناتٍ ترتبط ببطاقات الائتمان ، ولا تتحمل تمارا أي مسئولية عن أي خطأ أو ضرر أو أي أمر مثيل قد يتعرض له العميل من واقع أو جراء استخدام وسيلة السداد الإلكتروني، حيث يقع ذلك على مسئولية مقدم الخدمة من الغير.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١١</strong> ويكون على العميل أن يضمن وجود تغطية مالية كافية في الحساب ذو الصلة، بحيث يُمكن تغطية الطلبيات، كما يكون عليه الالتزام بحدود معاملات بطاقة الائتمان.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١١</strong> بموجب هذه الاتفاقية فأنت (العميل) توافق وتفوض تمارا في سحب المبلغ من حساب البطاقة المخزنة في حسابك (حساب العميل) لدى تمارا في التاريخ المستحق للسداد . وفي حال تم رفض العملية لعدم وجود مبالغ تغطي القسط سوف يتم المحاولة كل يومين (يوم نعم ويوم لا) لحين سداد المبلغ كاملا.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١١</strong> قد تفرض تمارا رسوم إضافية على المستخدمين من واقع إجراء عملية السداد الكترونياً.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.١١</strong> ويجوز لتمارا القيام (وحسب مطلق اختيارها بل وفي أي حين) بإبداء أية استفساراتٍ تراها ضرورية (وذلك سوءاً بصورة مباشرة أو من خلال الغير)، كما يجوز لها أن تطلب منكم موافاتها بالمزيد من المعلومات أو المستندات، ومن ذلك على وجه العموم لا الحصر أية معلومات أو مستندات تلزم للتحقق من هويتكم و/أو ملاءتكم المالية. فأنت تقر وتوافق على توفير أية معلوماتٍ و/أو مستنداتٍ إلى تمارا فور طلبه إياها. كما إنك تقر وتوافق الإقرار والموافقة على أنه إذا تعذر عليكم ذلك، فيجوز لتمارا القيام - ودونما أية مسئولية عليها- بإلغاء المعاملة أو تقييد أو إيقاف إمكانية دخولكم على الموقع الإلكتروني و/أو سحب عضويتكم منه.',
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١١</strong> بموجب هذه الاتفاقية، انت تقر بملائتك المالية وقدرتك على الوفاء بجميع الالتزامات المالية لتمارا، كما توافق على علمك المسبق بأن تمارا لديها الحق في التعاون مع التاجر مقدم الخدمة أو البضاعة في حال تخلفك عن سداد الدفعات. هذا التعاون قد يشمل (ايقاف الاشتراك أو الخدمة، الحجز على المنتج أو البضاعة) لحين اكتمال سداد الدفعات',
  },
  {
    type: 'text',
    content:
      '<strong>١١.١١</strong> أنت توافق بموجب هذه الاتفاقية على تفهمك وتحملك للعواقب المحتملة عند استخدام الخدمة التمويلية خلافاً للشروط المتفق عليها. وتوافق على أحقية تمارا (وحسب مطلق اختيارها) بإخطار الشركة الاتحاد للمعلومات الائتمانية ("AECB") في حالة تأخرك أو عجزك عن السداد.',
  },
  {
    type: 'text',
    content:
      '<strong>١١.١٢</strong> أنت توافق بموجب هذه الاتفاقية على أنك المستفيد الحقيقي من هذه الاتفاقية وأنك لا تستخدم خدمات تمارا في أي من عمليات غسل الأموال.',
  },
  {
    type: 'subtitle',
    content: '١٢. استرداد المدفوعات:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٢</strong> تمارا ليست مسؤولة تجاهك فيما يتعلق بأي عملية استرداد مدفوعات، في حين أن تمارا قد تؤدي دوراً في تسهيل عمليات استرداد المدفوعات وإعادة الأموال فيما بينك وبين التاجر أو منصة التجار وفقاً لتقديرها المطلق، فإن هذا الدور لا ينطوي على أية مسؤولية فيما يتعلق باسترداد المدفوعات.',
  },
  {
    type: 'subtitle',
    content: '١٣. السرية والخصوصية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٣</strong> تلتزم (تمارا) بكافة الطرق المهنية المعقولة في المحافظة على سرية المعلومات الائتمانية والبيانات التي في حوزتها، وعدم استخدامها أو تبادلها فيما بينها وبين الأشخاص والأطراف ذوي العلاقة إلا في حدود ووفق ما ورد في نظام المعلومات الائتمانية ولائحته التنفيذية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٣</strong> أنت توافق بموجب هذه الاتفاقية على تقديم أية معلومات، بما في ذلك معلومات التعريف أو الوثائق المطلوبة بشكل معقول من جانب تمارا للتحقق من هويتك فيما يتعلق بحساب تمارا أو أي استخدام لخدمات الدفع من تمارا، وتصرح لنا بطرح أية استفسارات نعتقد أنها ضرورية من أجل التحقق من هويتك. وتحتفظ تمارا بالحق في إغلاق حساب تمارا الخاص بك أو تعليق وصولك إلى خدمات الدفع من تمارا أو تقييده إذا تعذّر علينا الحصول على أي من هذه المعلومات أو التحقق منها على نحوٍ يُرضينا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٣</strong> أنت توافق بموجب هذه الاتفاقية وتفوض تمارا في استخدام أي من أو جميع معلومات التعريف و البيانات الشخصية الخاصة بك التي تم جمعها من خلال المواقع الإلكترونية أو المنصات أو تطبيقات الهواتف المحمولة الخاصة بتمارا أو التجار من وقتٍ لآخر ويجوز استخدامها أو الإفصاح عنها إلى أشخاص آخرين . وقد يشمل ذلك مشاركة معلومات التعريف الخاصة بك وأية معلومات أخرى مع أطراف خارجية لأغراض التحقق من الائتمان ومكافحة غسل الأموال أو غيرها من الفحوصات المماثلة أو لأي غرض آخر تعتبره تمارا ضروريًا من أجل تمكين تمارا من تقديم خدمات الدفع لك والالتزام بجميع القوانين واللوائح المعمول بها.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١٣</strong> أنت توافق بموجب هذه الاتفاقية وعند الدخول أو استخدام المواقع الإلكترونية أو تطبيقات الهواتف المحمولة الخاصة بتمارا، على سياسة السرية، مع إدراكك وعلمك بأنه يتم تجميع معلوماتك الشخصية وتفهمك لكيفية التعامل معها.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١٣</strong> إذا كنت لا توافق على سياساتنا وممارساتنا، فلن تتمكن من استخدام المواقع الإلكترونية أو تطبيقات الهواتف المحمولة الخاصة بتمارا ويرجى عدم متابعة استخدام خدماتنا.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١٣</strong> يحق للعملاء سحب موافقتهم على معالجة بياناتهم الشخصية في أي وقت، وفقًا للقيود التعاقدية والقانونية والإشعار الكتابي.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١٣</strong> لا تسمح تمارا للعميل (المتعاقد مع تمارا) الإفصاح للغير عن أية معلوماتٍ ترد إليه بموجب هذه الاتفاقية أو عقد خدمة مُـبرم مع تمارا ، بل وينبغي أن لا يتم الدخول على أية معلوماتٍ ترتبط بأعمال تمارا على نحو تشمله السرية، وذلك في الحدود التي قد تؤثر سلباً على أعمال تمارا، ويتحمل العميل المسؤولية عن تعويض تمارا عن أية خسارة في العمل أو في السمعة، إن حدث ذلك جراء أي تصرف يقع من العميل.',
  },
  {
    type: 'subtitle',
    content: '١٤. حدود المسئولية:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٤</strong> تمارا مزود خدمة مستقل وليست طرفًا في أي ترتيبات مباشرة بين العملاء والتجار أو أي أطراف ثالثة أخرى ذات صلة. لن تكون تمارا مسؤولة بأي حال من الأحوال عن أي مطالبة أو نزاع يُنسَب إلى التجار ولن تكون مسؤولة عن أي إخفاق أو أضرار ناجمة عن علامة مُنتَجات أو خدمات التجار أو الموثوقية أو الكفاية أو الأصالة أو التوفر أو الشرعية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٤</strong> التجار الخارجيون هم مقدمو خدمة مستقلون لا يخضعون لهذه الشروط والأحكام ويتعاقدون فقط مع تمارا. لا يُعَدّ التجار موظفين أو ممثلين أو وكلاء لشركة تمارا. ويتحمل التجار المسؤولية الكاملة عن جميع المعاملات التي تتم بينهم وبين العملاء أو المعاملات الأخرى ذات الصلة، وفي حالة وجود نزاع بينكم وبين أي تاجر أو طرف ثالث، فإنّكم تتعهدون بإبراء ذمة تمارا من أية مسؤولية تنشأ عن أو تتعلق بهذه النزاعات. وبهذا التعهد تعفون تمارا (ووكلائها وموظفيها) من المطالبات والمطالب والالتزامات والتعويضات من أي نوع أو طبيعة، معروفة أو غير معروفة، مُفصَح عنها أو غير مُفصَح عنها، ناشئة عن هذه النزاعات أو متعلقة بها بأي شكل من الأشكال.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٤</strong> من خلال الموافقة على هذه الشروط والأحكام، فإنّك تقرّ بإمكانية حدوث مخاطر أو أخطاء من التجار أو أي من مزودي الخدمات الخارجيين. لذا، يكون استخدام خدمات تمارا واقعًا ضمن نطاق مسؤوليتكم الحصرية ولا تتحمل تمارا أية مسؤولية تجاهها.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١٤</strong> لن تكون تمارا مسؤولة تجاهك أو تجاه أي شخص آخر عن أية أضرار مباشرة أو غير مباشرة أو عرضية أو خاصة أو جزائية أو عقابية أو تبعية قد تنشأ، حتى لو جرى إبلاغ تمارا بإمكانية حدوث هكذا أضرار، ولن تكون تمارا كذلك مسؤولة عن أية أضرار أو التزامات أو خسائر تتكبدها، والتي تنشأ عن استخدامك للخدمات أو اعتمادكم عليها، أو نتيجة لعدم قدرتكم على الوصول إلى الخدمات أو استخدامها، أو عن أي معاملة أو علاقة نشأت بينكم وبين التاجر، حتى عندما كانت تمارا على علم بإمكانية حدوث هكذا أضرار. ولن تكون تمارا مسؤولة عن أي تأخير أو فشل في التنفيذ، ولن تتحمل المسؤولية في حالة عدم حصول التاجر على التراخيص والتصاريح المناسبة.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١٤</strong> تُقَدَّم الخدمات على أساس "حالتها التي هي عليها"، وتُخلِي تمارا مسؤوليتها عن جميع الإقرارات والضمانات، الصريحة أو الضمنية، أو النظامية التي لم تُذكَر صراحةً في هذه الشروط والأحكام، بما في ذلك الضمانات الضمنية فيما يتعلق بقدرة البائع ومدى ملاءمته لخدماته لغرض معين. ولا تُقَدِّم تمارا أي إقرار أو ضمان حول الموثوقية أو الجودة أو الاستدامة أو التوفر أو المالك الأصلي للخدمات أو السلع أو أية خدمات تُطلَب من خلال استخدام خدمات تمارا، ولا تضمن تمارا عدم انقطاع الخدمات أو خلوها من الأخطاء. وإلى أقصى حد تسمح به الأنظمة المنطبقة، تقرّون وتوافقون بمُوجِبه على أنّكم تتحملون جميع المسؤوليات الناشئة عن استخدامكم لأيٍّ من الخدمات التي تقدمها تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١٤</strong> نوفِّر المعلومات الموجودة على الموقع الإلكتروني وتطبيق الجوال للأغراض العامة فقط. وتبذل تمارا جهودًا معقولة لإبقاء المعلومات مُحَدَّثَة وصحيحة، ولكنها لا تقدم أية تعهدات أو ضمانات من أي نوع، سواء أكانت صريحة أم ضمنية، من حيث اكتمال أو دقة أو موثوقية أو ملاءمة أو توفر الموقع أو تطبيقات الجوال أو المعلومات أو الخدمات أو الإعلانات أو الرسومات ذات الصلة الموجودة على الموقع الإلكتروني أو تطبيق الجوال لأي غرض، وبالتالي يجب عليكم الاعتماد على هذه المعلومات على مسؤوليتكم الخاصة.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١٤</strong> أسباب تتعلق بالأمان والأداء، تُراقَب جميع حسابات تمارا بانتظام.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١٤</strong> تمارا غير مسؤولة عن أي تأخير أو انقطاع أو فشل في تقديم الخدمات بسبب حدث قوة قاهرة.',
  },
  {
    type: 'text',
    content:
      '<strong>٩.١٤</strong> أنتم تقرّون وتوافقون بمُوجِبه على تعويض واحتجاز تمارا وأي من الشركات التابعة لها ومسؤوليها ومديريها وموظفيها ووكلائها من وضد أي وجميع المطالبات أو الالتزامات أو الأضرار أو الخسائر أو المصروفات أو النفقات، بما في ذلك على سبيل المثال لا الحصر، الرسوم النظامية والمحاسبية الناشئة عن أو المتعلقة بأي شكل من الأشكال بما يلي:',
  },
  {
    type: 'subtitle',
    content: [
      '(أ) وصولكم إلى أو استخدامكم أو عدم قدرتكم على استخدام حساب تمارا أو خدمات تمارا.',
      '(ب) إهمالكم أو سوء سلوككم.',
      '(ج) انتهاككم لأية أنظمة منطبقة؛ و/أو.',
      '(د)فشلكم في تقديم معلومات صحيحة ودقيقة وحديثة وكاملة والحفاظ عليها فيما يتعلق بحساب تمارا الخاص بكم.',
    ],
  },
  {
    type: 'text',
    content:
      '<strong>١٠.١٤</strong> إذا كنتم لا توافقون على أي بند من هذه الشروط والأحكام، فلا يجوز لكم الوصول إلى الموقع الإلكتروني أو تطبيق الجوال، ولا استخدام خدمات تمارا.',
  },
  {
    type: 'subtitle',
    content: '١٥. تَعَهُّد:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٥</strong> يشكل هذا البند إشعارًا لك بأننا تعهدنا بجميع حقوقنا وحقوقنا وفوائدنا في هذه الشروط والأحكام ، ما في ذلك الحق في استقطاع أي مبلغ مستحق الدفع بواسطتك وفقًا لهذه الشروط والأحكام. وعليه ستظل شركة تمارا مؤهله لممارسة جميع حقوقها وصلاحيتها في التقدير وطرق الانتصاف ويجب عليك الالتزام بدفع أي مبلغ مستحق الدفع من قبلك ، ما لم تتلقى إشعارًا كتابيًا بخلاف ذلك. وفي هذه الحالة، يحق لك المطالبة بجميع الحقوق والسلطات والتقديرات وسبل الانتصاف، وذلك بموجب إشعار، كما أنك من خلال الموافقة على هذه الشروط والأحكام، فإنك تقر وتقبل شروط هذا البند.',
  },
  {
    type: 'subtitle',
    content: '١٦. التعويض:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٦</strong> أنت تقرّ وتوافق على تعويض ودرء الضرر عن تمارا وما يتبعها من كيانات وجهات راعية وشركاء ومديرية والتزام وموظفين وسداد جميع الخسائر التي تكبدتها وكذلك قيمة الأضرار والمسؤوليات والمطالبات والأحكام والتسويات والغرامات والتكاليف والنفقات (بما في ذلك أيّة مصاريف وأتعاب نظامية وتكاليف التحقيق وأتعاب المحاماة). في حالة تعرُّض تمارا لأية أضرار تسببتم بها أو إذا نَشَأَت أو كانت مرتبطة بخرقكم لهذه الشروط والأحكام أو سياسة الخصوصية أو استخدامكم أو استخدام طرف ثالث (متعاقد معكم) للخدمات.',
  },
  {
    type: 'subtitle',
    content: '١٧. الإشعارات',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٧</strong> يجب أن تكون جميع الإشعارات والمراسلات الأخرى بمُوجِب هذه الشروط والأحكام مكتوبة عن طريق المراسلة إلى بريد تمارا الإلكتروني المعروض على موقع تمارا الإلكترون.',
  },
  {
    type: 'subtitle',
    content: '١٨. أحكام عامة',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٨</strong> تخضع حقوق والتزامات الأطراف الواردة في هذه الشروط والأحكام وتُفَسَّر وَفقا لأحكام أنظمة المملكة العربية السعودية.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٨</strong>بالموافقة على هذه الشروط والأحكام، فإنّك تتعهد بالخضوع دون قيد أو شرط للاختصاص القضائي الحصري لمحاكم المملكة العربية السعودية فيما يتعلق بأي إجراءات نظامية ناشئة عن أو متعلقة بهذه الشروط والأحكام، أو العلاقات النظامية التي نشأت عنها، أو الموضوعات المختلفة الواردة هنا. يتنازل الطرفان بمُوجِبه ويوافقان على عدم التأكيد (عن طريق رفع طلب أو مذكرة دفاع أو غير ذلك) على أن أي إجراء مماثل قد اتُّخِذَ في محكمة مختصة غير ملائمة أو لدى مَقَرّ غير مناسب.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٨</strong>أنتم توافقون بمُوجِبه على التعاون مع تمارا إلى أقصى حد تسمح به الأنظمة المنطبقة، بما في ذلك الموافقة على الإجابة كتابيًا على أي أسئلة أو تقديم معلومات لمساعدة تمارا في إجراء أي تحقيق داخلي أو استفسار.',
  },
  {
    type: 'text',
    content:
      '<strong>٤.١٨</strong>بمُوجِب هذه الشروط والأحكام، تقرّون بأن تمارا قد تفصح عن معلومات عنكم وعن حسابكم المذكور أعلاه أو أي حساب آخر مع أي مُنَظِّمِين بمُوجِب الأنظمة المنطبقة، وأي قواعد سارية لاتحاد البطاقات المصرفية نافذة من وقت لآخر، و/أو الممثل المعتَمَد للمُنَظِّمِين ذوي الصّلة، بما في ذلك، على سبيل المثال لا الحصر، الشركة السعودية للمعلومات الائتمانية (سمة) من خلال اتفاقية العضوية المبرمة وقواعد العمل المعتمدة لتبادل المعلومات و/أو مع أي طرف آخر على نحو ما يعتمده البنك المركزي السعودي ("ساما") أو أية مؤسسة مالية محلية أخرى ذات صلة.',
  },
  {
    type: 'text',
    content:
      '<strong>٥.١٨</strong>إذا تقرر انعدام صلاحية أو نفاذ أو سريان أيَّ شرط أو حكم من هذه الشروط والأحكام، فسيُعَدّ هذا الشرط أو الحكم فقط غير ساري دون التأثير بأي شكل من الأشكال على بقية هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>٦.١٨</strong>تصبح هذه الشروط والأحكام سارية في التاريخ الذي تدخلون فيه إلى موقعنا الإلكتروني أو تطبيقنا و/أو في التاريخ الذي تشيرون فيه إلى موافقتكم عبر إنشاء حساب تمارا وستظل سارية إلى حين إلغاء أو إبطال تمارا لها وَفقا لتقديرها الكامل.',
  },
  {
    type: 'text',
    content:
      '<strong>٧.١٨</strong>إذا اختارت تمارا، وَفقا لتقديرها الخاص، إلغاء تنشيط وصولك إلى حساب تمارا الخاص بكم، وبالتالي إنهاء هذه الشروط والأحكام، فسيتم اخطاركم من تمارا عن طريق إرسال إشعار إلى عنوان البريد الإلكتروني الذي قدمتموه إلى تمارا. وأنتم توافقون وتقرّون بمُوجِبه بأن لتمارا الحق المطلق في إنهاء هذه الشروط والأحكام بسبب أو بدون سبب وليس عليها أي التزام بإعلامكم بسبب إنهاء هذه الشروط والأحكام.',
  },
  {
    type: 'text',
    content:
      '<strong>٨.١٨</strong>بإغلاق حساب تمارا الخاص بكم باتّباع الإرشادات الموجودة على موقع تمارا الإلكتروني أو تطبيق تمارا، ستوقف انطباق هذه الشروط والأحكام. وتجنّبًا للشك، ستظلون مسؤولين عن جميع الالتزامات المتعلقة بحساب تمارا الخاص بكم وجميع المبالغ المترصدة في ذمتكم لصالح تمارا (بما في ذلك الرسوم المتأخرة) حتى بعد إغلاق حساب تمارا الخاص بكم و/أو ايقاف تطبيق هذه الشروط والأحكام.',
  },
  {
    type: 'subtitle',
    content: '١٩. الشكاوَى:',
  },
  {
    type: 'text',
    content:
      '<strong>١.١٩</strong> نحن ملتزمون بتقديم مستوى خدمة ممتاز لعملائنا. ونحن نُقَدِّر ملاحظات العملاء كثيرًا لأنها تساعدنا على تحسين خدماتنا باستمرار. فإذا كنتم لا تشعرون أنّكم تتلقون خدمة عملاء ممتازة، أو أنه يمكن تحسين شيءٍ ما، فنرجو إخبارِنا بذلك.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.١٩</strong> اذا أخفقنا في تلبية المعايير العالية التي وضعناها لأنفسنا، فإننا نرغب في إتاحة الفرصة لوضع الأمور في نصابها الصحيح. ومع ذلك، فإننا ندرك أن الأمور قد تسوء من حين لآخر، وإن حدث ذلك، فنحن ملتزمون بحلّ الأمور حَلًّا فوريًّا وعادلًا. في حال رغبتك برف شكوى يرجي التواصل معنا من خلال الرقم الآتي:8001240441ا.',
  },
  {
    type: 'text',
    content:
      '<strong>٣.١٩</strong> عند تلقي أي شكوى سيتم اتخاذ الاجراءات الاتية : (1) إرسال إقرار كتابي عن الشكوى في غضون خمسة (5) أيام عمل من استلامها وابلاغكم بأي تفاصيل ناقصة قد نطلبها لإتمام معالجة الشكوى؛ (2) التحقيق في المخاوف وترتيب مناقشة معكم لمحاولة الاتفاق على كيفية حل المشكلات؛ (3) الرد بقرارنا النهائي بشأن هذه المسألة، وتحديد نتيجة تحقيقنا وأي مقترحات لتصحيح الأمر أو حله، في غضون عشرة (10) أيام عمل من تلقي شكواكم الكاملة؛ و(4) تذكيركم بأنه قد يحق لكم إحالة شكواكم إلى البنك المركزي السعودي ("ساما") وتقديم تفاصيل لفعل ذلك، في نهاية عملية تقديم الشكاوى لديناا.',
  },
  {
    type: 'subtitle',
    content: '٢٠. الأخطاء:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٢٠</strong> في حال علمنا بوجود أي خطأ أو عطل في حساب تمارا الخاص بكم، سنتّخذ ما يلي: (1) الإعادة الفورية لأي مبالغ جرى تحصيلها نتيجة لهذا الخطأ، حسب الاقتضاء؛ (2) معالجة هذه الأخطاء وتصحيحها لأي عملاء متأثرين في غضون ستين (60) يوم عمل بدءًا من تاريخ تحديد الخطأ؛ و(3) إبلاغكم بهذا الخطأ واتخاذ الإجراءات التصحيحية.',
  },
  {
    type: 'subtitle',
    content: '٢١. الاتفاق الكامل:',
  },
  {
    type: 'text',
    content:
      '<strong>١.٢١</strong>  تمثل هذه الشروط والأحكام، جنبًا إلى جنب مع سياسة الخصوصية وأي شروط أخرى متفق عليها بينكم وبين تمارا من وقت لآخر، مجمل ما جرى الاتفاق عليه فيما بينكم وبين تمارا.',
  },
  {
    type: 'text',
    content:
      '<strong>٢.٢١</strong>مُوجِبه، أوافق أنا المُوَقِّع أدناه على أن أوفّر لـشركة نخلة لتقنية نظم المعلومات ذ.م.م (تمارا) أيّة معلومات تتطلبها لإنشاء و/أو تدقيق و/أو إدارة حساباتي والتسهيلات بها وأصرح لها بالحصول على أيّة معلومات وجمعها حسبما تراه ضروريًا أو بحاجة إليها فيما يتعلق بي وبحساباتي والتسهيلات ذات الصلة، من الشركة السعودية للمعلومات الائتمانية (سمة) والإفصاح عن هذه المعلومات ومشاركتها (بما في ذلك تجميع البيانات) للشركة المذكورة (سمة) وَفقا لاتفاقية العضوية وقواعد السلوك المعتمدة أو إلى أي وكالة أخرى معتمدة من البنك المركزي السعودي (ساما).',
  },
]
